import axios from '@/api/axios'

const Helpers = {
    nameCheck: value => {
        if (value === '' || value === undefined || value === null)
            return false;
        value = value.trim()
        return /^[а-яёa-z\.\(\)_0-9]+([- \`\'\(\)_0-9]{1}[а-яёa-z\.\(\)_0-9]+)*\.?$/i.test(value) ? true : false
    },
    statusCheck: value => {
        if (value === '' || value === undefined || value === null)
            return false;
        return /^[1|2|3]$/.test(value) ? true : false
    },
    phoneCheck: value => {
        if (value === '' || value === undefined || value === null)
            return false;
        return /^\+7\s\(9\d{2}\)\s\d{3}-\d{2}-\d{2}$/i.test(value) ? true : false;
    }
}

export const globalMethods = {
    methods: {
        checkName(data) {
            return new Promise((resolve, reject) => {
                if (!data?.name) {
                    return reject('Отсутсвует имя')
                } else if (!Helpers.nameCheck(data.name)) {
                    return reject('Некорректное имя')
                } else {
                    return resolve(data)
                }
            })
        },
        checkStatus(data) {
            return new Promise((resolve, reject) => {
                if (!data?.status) {
                    return reject('Отсутсвует статус')
                } else if (!Helpers.statusCheck(data.status)) {
                    return reject('Некорректный статус')
                } else {
                    return resolve(data)
                }
            })
        },
        checkPhone(data) {
            return new Promise((resolve, reject) => {
                if (!data?.phone) {
                    return reject('Отсутсвует телефон')
                } else if (!Helpers.phoneCheck(data.phone)) {
                    return reject('Некорректный телефон')
                } else {
                    return resolve(data)
                }
            })
        },
        valueModel(value, obj, field) {
            this.$set(obj, field, value)
        },
        checkAccess(adminType, forOpen) {
            if (Array.isArray(forOpen)) {
                if (forOpen.includes(adminType)) {
                    return true
                } else {
                    return false
                }
            } else {
                if (adminType === forOpen) {
                    return true
                } else {
                    return false
                }
            }
        },
        sendRequest(method, data, url, currentHeaders = {}, preloader, plug) {
            const dataOrParams = ['GET', 'DELETE'].includes(method) ? 'params' : 'data';
            axios.defaults.baseURL = process.env.NODE_ENV !== 'production' ? 'http://localhost:3301' : 'http://localhost:3301'

            if (!currentHeaders || !currentHeaders?.['Content-Type'] || !currentHeaders?.['content-type']) {
                axios.defaults.headers.common['Content-Type'] = 'application/json';
            }

            let headers = {
                withCredentials: true,
                ...currentHeaders,
            }

            if (preloader) {
                this.$store.commit('showPreloader', true)
            }
            const errorMessage = (err) => {
                if (err?.response?.data) {
                    if (err?.response?.headers['content-type'] && err.response.headers['content-type'].indexOf('text/html') > -1) {
                        return err.message
                    } else {
                        if (err?.response?.data?.message) {
                            return err.response.data.message;
                        } else {
                            return err.response.data;
                        }
                    }
                } else {
                    return err.message;
                }
            }
            return new Promise((resolve, reject) => {
                if (plug) {
                    setTimeout(() => {
                        this.$store.commit('showPreloader', false)
                        resolve([])
                    }, 1000)
                } else {
                    axios.request({
                        url,
                        method,
                        [dataOrParams]: data,
                        headers: headers
                    })
                        .then(({ data }) => {
                            resolve(data)
                        })
                        .catch((err) => {
                            reject(errorMessage(err))
                        })
                        .finally(() => {
                            this.$store.commit('showPreloader', false)
                        });
                }
            })
        },
        number_format(number, decimals, dec_point, thousands_sep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + (Math.round(n * k) / k)
                        .toFixed(prec);
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
                .split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '')
                .length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1)
                    .join('0');
            }
            return s.join(dec);
        }
    }
}